module.exports = __webpack_public_path__ + "static/media/checkmark_circle.6d290c9b.svg";